import { Chip, ListItemButton, ListItemIcon, ListItemText, Stack } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { Classification } from "routes/schedule/tasks/classification"

const ICON_SIZE = 18

export function MaintenanceTaskElementSelectorTaskItem({ item }) {
    const { selectedTaskId, setSelectedTaskId, showPath, compact } = useBoundContext()
    const isSelected = selectedTaskId === item.id
    const frequencyCode = item.frequencyCode || item.frequency?.code
    const secondaryText = showPath ? formatCategoryPath(item.categoryPath) : null

    return (
        <ListItemButton dense selected={isSelected} onClick={handleClick} data-cy={`maintenance-task-${item.id}`}>
            <If value={compact}>
                <ListItemIcon sx={{ minWidth: 22 }}>
                    <If value={item.classification}>
                        <Classification classification={item.classification} boxSx={iconSizeSx()} />
                    </If>
                </ListItemIcon>
                <ListItemText
                    primary={item.heading || "Untitled Component"}
                    primaryTypographyProps={{ variant: "caption", noWrap: true }}
                    sx={{ my: 0 }}
                />

                <Else>
                    <Stack spacing={0.25} width={1} sx={{ py: 0.25 }}>
                        <Stack direction="row" spacing={1} width={1} alignItems="center">
                            <ListItemText
                                primary={item.heading || "Untitled Component"}
                                secondary={secondaryText}
                                primaryTypographyProps={{ variant: "body2" }}
                                secondaryTypographyProps={{ variant: "caption", noWrap: true }}
                                sx={{ my: 0 }}
                            />
                            <If value={item.classification}>
                                <Classification classification={item.classification} />
                            </If>
                            <If value={frequencyCode}>
                                <Chip size="small" variant="outlined" label={frequencyCode} />
                            </If>
                        </Stack>
                        <If value={item.skillSet}>
                            <Chip
                                size="small"
                                label={item.skillSet}
                                sx={{
                                    alignSelf: "flex-start",
                                    height: 18,
                                    fontSize: "0.65rem",
                                    bgcolor: "action.hover",
                                    border: "none",
                                }}
                            />
                        </If>
                    </Stack>
                </Else>
            </If>
        </ListItemButton>
    )

    function handleClick() {
        setSelectedTaskId(item.id)
    }
}

function iconSizeSx() {
    return { "& svg": { width: ICON_SIZE, height: ICON_SIZE } }
}

function formatCategoryPath(path) {
    if (!path) return ""
    return path.replace(/^Components\//, "").replace(/\//g, " › ")
}
